module.exports = __webpack_public_path__ + "static/media/virtual-campus.5c55232c.svg";